//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BtnFollow from '@/components/public/btn-follow.vue';
import * as api from '~/api/index';
import pagination from '~/components/public/component-pagination';
export default {
  components: {
    BtnFollow,
    pagination,
  },
  async asyncData({ error, $axios }) {
    try {
      const articleList = await $axios(
        api.getRecommendColumns({
          page: 1,
          count: 16,
        })
      );
      const total =
        articleList && articleList.totalCount ? articleList.totalCount : 0;
      return {
        articleList:
          articleList && articleList.result ? articleList.result : [],
        total,
      };
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      error({
        statusCode: 404,
        message: '文章不存在',
      });
    }
  },
  data() {
    return {
      currentPage: 1,
      goTop: true,
    };
  },
  mounted() {
    this.moreArticle();
  },
  methods: {
    async moreArticle() {
      const articleList = await this.$axios(
        api.getRecommendColumns({
          page: this.currentPage,
          count: 16,
        })
      );
      // ++this.currentPage;
      this.total = articleList.totalCount;
      this.articleList = articleList.result;
    },
    pageChange(internalCurrentPage) {
      this.currentPage = internalCurrentPage;
      this.moreArticle();
    },
  },
};
